import { RespondentModel } from "../RespondentModel";
import { DispositionCode } from "../enums/DispositionCode";

export function createRespondent(el?: any): RespondentModel {
    if (el == null) return undefined;
    return {
        id: el.id,
        respondentId: el.respondentId,
        simulated: el.simulated,
        isNew: el.isNew !== undefined ? el.isNew : el.respondentId === 0,
        seed: el.seed,
        email: el.email,
        phone: el.phone,
        timeZone: el.timeZone,
        pin: el.pin,
        language: el.language,
        ignoreForcedQuit: Boolean(el.ignoreForcedQuit),
        sessionStartTime: el.sessionStartTime,
        dispositionCode: (DispositionCode as any)[el.dispositionCode],
        prevSessionFirstAnsweredQuestion: el.firstAnsweredQuestion,
        prevSessionLastAnsweredQuestion: el.lastAnsweredQuestion,
        firstAnsweredQuestion: undefined,
        lastAnsweredQuestion: undefined,
        appointmentDate: el.appointmentDate,
        offlineUserId: el.offlineUserId,
        offlineUserName: el.offlineUserName,
        ipAddress: el.ipAddress,
        panelistId: el.panelistId,
        sampleId: el.sampleId,
        panelistPoints: el.panelistPoints,
        accessCount: el.accessCount,
        inputAccess: el.inputAccess,
        resSelectedSecurityQuestionId: el.resSelectedSecurityQuestionId,
        isResLocked: el.isResLocked,
        responseQualityFlagged: el.responseQualityFlagged,
        responseQualityReasonCodes: el.responseQualityReasonCodes,
    };
}
